// import { Button } from "react-bootstrap";
import React, { useState } from "react";
import "./contactUs.css";
import Swal from "sweetalert2";
import firebase from "firebase/compat/app";
import firebase_, { firestore } from "../../firebase/firebase";
export default function ContactUs() {
  const [phoneNumber, setphoneNumber] = useState("");
  const [fullName, setfullName] = useState("");
  const [description, setdescription] = useState("");
  const [emailId, setemailId] = useState("");
  const timestamp = firebase.firestore.FieldValue.serverTimestamp();
  const type = "contactform";

  const handleSubmit = (e) => {
    e.preventDefault();

    const saveData = {
      to: emailId,
      cc: ["contact@scrobits.com", "digvijay.scrobits@gmail.com"],
      message: {
        subject: "Greetings from ScroBits Technologies",
        text: `Hi ${fullName}, Thank you for taking interest in Scrobits Technologies. Someone from our team will contact you as soon as possibleto help you with your query : ${description}`,
        html: "",
      },
      fullName,
      description,
      emailId,
      phoneNumber,
      type,
      timestamp,
    };
    firestore
      .collection("EmailQueries")
      .add(saveData)
      .then((docRef) => {
        Swal.fire({
          position: "top",
          icon: "success",
          title: "We will get back to you in 24hrs",
          showConfirmButton: false,
          timer: 1500,
        });
        // console.log("doc", docRef);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  /**
   * This function handles all input and assigns them in variable
   * @param {e} e Event to trigger
   */
  const handleChange = (e) => {
    if (e.target.name === "fullName") {
      setfullName(e.target.value);
    } else if (e.target.name === "phoneNumber") {
      setphoneNumber(e.target.value);
    } else if (e.target.name === "emailId") {
      setemailId(e.target.value);
    } else if (e.target.name === "description") {
      setdescription(e.target.value);
    }
  };
  return (
    <div className="scrobits__contact section__padding" id="contact-us">
      {/* <ThreeDemo /> */}
      <div className="scrobits__contact-heading">
        <h1 className="gradient__text">
          You have a Vision? <br /> We have a way to get you there.
        </h1>
      </div>
      <div className="scrobits__contact-form__container">
        <div className="scrobits__contact-content">
          <h3>Get in touch!</h3>
          <p>We look forward to hearing from you😊</p>
          <button
            style={{ marginTop: "2%" }}
            className="scrobits__header-content__input-button"
          >
            <a
              href="https://scrobits.notion.site/ScroBits-Technologies-daaaf7ad1c474050ae5ef7a903cf0e22"
              target="_blank"
            >
              See our works!
            </a>
          </button>
        </div>
        <div className="scrobits__contact-form">
          <form
            className="scrobits__contact-form__container-box"
            onSubmit={handleSubmit}
          >
            <div className="form-group">
              <input
                type="text"
                name="fullName"
                id="firstName"
                className="form__input"
                placeholder=" "
                required
                onChange={handleChange}
              />
              <label htmlFor="firstName" className="form__label">
                Full Name
              </label>
            </div>

            <span>
              <div className="form-group">
                <input
                  type="email"
                  name="emailId"
                  id="email"
                  className="form__input"
                  value={emailId}
                  placeholder=" "
                  onChange={handleChange}
                />
                <label htmlFor="email" className="form__label">
                  Email
                </label>
              </div>
              <div className="form-group">
                <input
                  type="number"
                  name="phoneNumber"
                  id="phoneNumber"
                  value={phoneNumber}
                  className="form__input"
                  placeholder=" "
                  onChange={handleChange}
                />
                <label htmlFor="phoneNumber" className="form__label">
                  Phone Number
                </label>
              </div>
            </span>

            <div className="form-group form-textarea">
              <textarea
                name="description"
                className="form__input"
                id="message"
                cols="30"
                placeholder=" "
                rows="10"
                value={description}
                onChange={handleChange}
              />
              <label htmlFor="message" className="form__label">
                Tell us about your project or just say hi!
              </label>
            </div>
            <div className="form-group">
              <button className="form-submit-btn" type="submit">
                Send
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
